import { render, staticRenderFns } from "./SubscriberApi.vue?vue&type=template&id=2516bd16&scoped=true"
import script from "./SubscriberApi.vue?vue&type=script&lang=js"
export * from "./SubscriberApi.vue?vue&type=script&lang=js"
import style0 from "./SubscriberApi.vue?vue&type=style&index=0&id=2516bd16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2516bd16",
  null
  
)

export default component.exports